import { cn } from "@/utils/cn";
import { memo } from "react";

interface BookmarkCircleIconProps {
  className?: string;
}

/**
 * Bookmark icon with circular border
 */
export const BookmarkCircleIcon = memo(function BookmarkCircleIcon({
  className,
}: BookmarkCircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="66"
      viewBox="0 0 66 66"
      fill="none"
      className={cn("h-16.5 w-16.5", className)}
    >
      <circle cx="33" cy="33" r="32.25" stroke="white" strokeWidth="1.5" />
      <path
        d="M39.3 21H25.7C25.2491 21 24.8167 21.1731 24.4979 21.4812C24.1791 21.7893 24 22.2071 24 22.6428V43.2957C24 43.4214 24.0347 43.5448 24.1007 43.6531C24.1667 43.7615 24.2615 43.8507 24.3753 43.9117C24.489 43.9726 24.6176 44.003 24.7476 43.9998C24.8777 43.9965 25.0044 43.9596 25.1147 43.893L32.4988 39.4338L39.8853 43.893C39.9956 43.9596 40.1223 43.9965 40.2524 43.9998C40.3824 44.003 40.511 43.9726 40.6247 43.9117C40.7385 43.8507 40.8333 43.7615 40.8993 43.6531C40.9653 43.5448 41 43.4214 41 43.2957V22.6428C41 22.2071 40.8209 21.7893 40.5021 21.4812C40.1833 21.1731 39.7509 21 39.3 21ZM39.5429 42.0248L32.8849 38.0046C32.7691 37.9346 32.6353 37.8975 32.4988 37.8975C32.3622 37.8975 32.2284 37.9346 32.1126 38.0046L25.4571 42.0248V22.6428C25.4571 22.5806 25.4827 22.5209 25.5283 22.4769C25.5738 22.4329 25.6356 22.4081 25.7 22.4081H39.3C39.3644 22.4081 39.4262 22.4329 39.4717 22.4769C39.5173 22.5209 39.5429 22.5806 39.5429 22.6428V42.0248Z"
        fill="white"
      />
    </svg>
  );
});
